/** @format */

import React, { Component } from "react";
// import {Redirect} from 'react-router-dom';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Button, Modal } from "antd";
import { withRouter } from "react-router-dom";

import { actions as authActions } from "../../reducers/userReducer";
import SignIn from "./components/SignIn";
import SignUp from "./components/SignUp";
import { message } from "antd";

class SignInSignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signInVisible: false,
      signUpVisible: false,
    };
  }

  handleSignUp() {
    this.setState({ signUpVisible: true });
  }

  handleLogin() {
    this.setState({ signInVisible: true });
  }

  handleCancel(data) {
    this.setState({ signInVisible: false, signUpVisible: false });
    if (data && data.message) {
      message.success(data.message);
    }
  }

  render() {
    const { isLogin, signUpVisible, signInVisible } = this.state;

    return (
      <>
        <div>
          <span className="login-btn" onClick={() => this.handleLogin()}>
            Sign In
          </span>
          <Button
            type="primary"
            className="signup-btn"
            onClick={() => this.handleSignUp()}
          >
            Get Started
          </Button>
        </div>

        {!isLogin && !signInVisible && !signUpVisible ? null : (
          <>
            {/* 注册 Modal */}
            <Modal
              visible={signUpVisible}
              maskStyle={{ backgroundColor: "#ffffffe9" }}
              onCancel={() => {
                this.handleCancel();
              }}
              footer={null}
            >
              <SignUp
                loginSuccess={(data) => {
                  this.handleCancel(data);
                  this.props.history.push(`/tag`);
                }}
              />
            </Modal>

            {/* 登录Modal */}
            <Modal
              visible={signInVisible}
              maskStyle={{ backgroundColor: "#ffffffe9" }}
              onCancel={() => {
                this.handleCancel();
              }}
              footer={null}
            >
              <SignIn
                loginSuccess={() => {
                  this.handleCancel();
                }}
              />
            </Modal>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  username: state.userReducer.username,
  userImage: state.userReducer.userImage,
  userId: state.userReducer.userId,
});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      login: authActions.login,
    },
    dispatch
  );

SignInSignUp = connect(mapStateToProps, mapDispatchToProps)(SignInSignUp);

export default withRouter(SignInSignUp);
